// Shared EduPulse logo, rendered as a fixed-size element so no global image rule
// can stretch it. `size` = pixel height. `onDark` uses the white wordmark.
const RATIO = 2137 / 679; // logo content aspect ratio

export default function BrandMark({ size = 30, onDark = false, className = "", alt = "EduPulse" }) {
  return (
    <span
      role="img"
      aria-label={alt}
      className={"inline-block shrink-0 bg-contain bg-left bg-no-repeat " + className}
      style={{
        width: Math.round(size * RATIO),
        height: size,
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/${onDark ? "edu_logo-w.png" : "edu_logo.png"})`,
      }}
    />
  );
}
